import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const BACKEND = BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "iemc_admin_token";
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

// Public
export const fetchAllContent = () => api.get("/content").then((r) => r.data);
export const fetchCharters = () => api.get("/charters").then((r) => r.data);
export const fetchAvailability = (charterId) =>
  api
    .get("/availability", { params: charterId ? { charter_id: charterId } : undefined })
    .then((r) => r.data);
export const submitInquiry = (data) => api.post("/inquiries", data).then((r) => r.data);
export const createBooking = (data) => api.post("/bookings", data).then((r) => r.data);
export const getCheckoutStatus = (sessionId) =>
  api.get(`/checkout/status/${sessionId}`).then((r) => r.data);

// Admin
export const adminLogin = (email, password) =>
  api.post("/auth/login", { email, password }).then((r) => r.data);
export const adminMe = () => api.get("/auth/me").then((r) => r.data);
export const adminChangeCredentials = (data) =>
  api.post("/auth/change-credentials", data).then((r) => r.data);
export const adminGetPaymentSettings = () =>
  api.get("/admin/settings/payments").then((r) => r.data);
export const adminUpdatePaymentSettings = (data) =>
  api.put("/admin/settings/payments", data).then((r) => r.data);
export const adminGetEmailSettings = () =>
  api.get("/admin/settings/emails").then((r) => r.data);
export const adminUpdateEmailSettings = (data) =>
  api.put("/admin/settings/emails", data).then((r) => r.data);
export const adminSendTestEmail = (data) =>
  api.post("/admin/settings/emails/test", data).then((r) => r.data);

export const adminListMedia = () => api.get("/admin/media").then((r) => r.data);
export const adminDeleteMedia = (id) => api.delete(`/admin/media/${id}`).then((r) => r.data);
export const adminUploadMedia = (file, alt = "") => {
  const fd = new FormData();
  fd.append("file", file);
  fd.append("alt", alt);
  return api
    .post("/admin/media", fd, { headers: { "Content-Type": "multipart/form-data" } })
    .then((r) => r.data);
};
export const mediaUrl = (relativeOrAbsolute) => {
  if (!relativeOrAbsolute) return "";
  if (relativeOrAbsolute.startsWith("http")) return relativeOrAbsolute;
  if (relativeOrAbsolute.startsWith("/api/media/")) return `${BACKEND_URL}${relativeOrAbsolute}`;
  return relativeOrAbsolute;
};
export const adminStats = () => api.get("/admin/stats").then((r) => r.data);
export const adminUpdateContent = (key, data) =>
  api.put(`/content/${key}`, data).then((r) => r.data);
export const adminCreateCharter = (data) => api.post("/charters", data).then((r) => r.data);
export const adminDeleteCharter = (id) => api.delete(`/charters/${id}`).then((r) => r.data);
export const adminUpdateCharter = (id, data) =>
  api.put(`/charters/${id}`, data).then((r) => r.data);
export const adminListBookings = () => api.get("/bookings").then((r) => r.data);
export const adminPatchBooking = (id, data) =>
  api.patch(`/bookings/${id}`, data).then((r) => r.data);
export const adminApproveBooking = (id) =>
  api.post(`/bookings/${id}/approve`).then((r) => r.data);
export const adminRejectBooking = (id, reason = "") =>
  api.post(`/bookings/${id}/reject`, { reason }).then((r) => r.data);

// Public payment-link flow
export const getPayInfo = (bookingId, token) =>
  api.get(`/bookings/pay/${bookingId}`, { params: { token } }).then((r) => r.data);
export const createPayCheckout = (bookingId, token, originUrl) =>
  api
    .post(
      `/bookings/pay/${bookingId}/checkout`,
      { origin_url: originUrl },
      { params: { token } }
    )
    .then((r) => r.data);
export const adminListInquiries = () => api.get("/inquiries").then((r) => r.data);
export const adminListFeeds = () => api.get("/ical/feeds").then((r) => r.data);
export const adminAddFeed = (data) => api.post("/ical/feeds", data).then((r) => r.data);
export const adminSyncFeed = (id) => api.post(`/ical/feeds/${id}/sync`).then((r) => r.data);
export const adminDeleteFeed = (id) => api.delete(`/ical/feeds/${id}`).then((r) => r.data);
